var React = require('react');

function ArrowBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m0 0 8 4.681 8-4.681-.06.043-7.94 7.958z","fill":"#000","fillRule":"evenodd"}));
}

ArrowBlack.defaultProps = {"fill":"none","viewBox":"0 0 16 8"};

module.exports = ArrowBlack;

ArrowBlack.default = ArrowBlack;
